define("shared/components/shared/ui/past-post-limit-banner", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@glimmer/tracking", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _tracking, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/service",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cPM--modalBanner--upgrade">
    <div class="u--row">
      <div class="u--col__9">
        {{! Title }}
        <p class="cPM--modalBanner__title">
          {{this.postLimitTitle}}
        </p>
        {{! Text }}
        <p class="cPM--modalBanner__desc">
          {{this.postLimitDescription}}
        </p>
      </div>
      <div class="u--col__3">
        <Shared::Button::Upgrade
          class={{"u--float--right"}}
          @feature="getMorePosts"
          @location="post modal -- past post limit"
          @socialProfileType={{@socialProfileType}}
          @text={{this.postLimitButtonText}}
          @type="proceed"
        />
      </div>
    </div>
  </div>
  */
  {
    "id": "RFtjCK1k",
    "block": "[[[10,0],[14,0,\"cPM--modalBanner--upgrade\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--col__9\"],[12],[1,\"\\n\"],[1,\"      \"],[10,2],[14,0,\"cPM--modalBanner__title\"],[12],[1,\"\\n        \"],[1,[30,0,[\"postLimitTitle\"]]],[1,\"\\n      \"],[13],[1,\"\\n\"],[1,\"      \"],[10,2],[14,0,\"cPM--modalBanner__desc\"],[12],[1,\"\\n        \"],[1,[30,0,[\"postLimitDescription\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--col__3\"],[12],[1,\"\\n      \"],[8,[39,0],[[24,0,\"u--float--right\"]],[[\"@feature\",\"@location\",\"@socialProfileType\",\"@text\",\"@type\"],[\"getMorePosts\",\"post modal -- past post limit\",[30,1],[30,0,[\"postLimitButtonText\"]],\"proceed\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@socialProfileType\"],false,[\"shared/button/upgrade\"]]",
    "moduleName": "shared/components/shared/ui/past-post-limit-banner.hbs",
    "isStrictMode": false
  });

  let PastPostLimitBanner = (_dec = (0, _service.inject)('schedule/post'), (_class = class PastPostLimitBanner extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);

      _initializerDefineProperty(this, "schedulePost", _descriptor4, this);

      _initializerDefineProperty(this, "postLimitDescription", _descriptor5, this);

      this.getPostLimitDescription();
    }

    get postLimitTitle() {
      return this.schedulePost.getPostLimitTitle(this.args.socialProfileType);
    }

    get postLimitButtonText() {
      return this.auth.currentAccount.canTrialPlan ? this.intl.t('shared_phrases.upgrade_trial') : this.intl.t('shared_phrases.upgrade_plan');
    }

    async getPostLimitDescription() {
      this.postLimitDescription = await this.schedulePost.getPostLimitDescription(this.args.socialProfileType);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "schedulePost", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "postLimitDescription", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  })), _class));
  _exports.default = PastPostLimitBanner;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PastPostLimitBanner);
});